import type { AgentWorkspaceAnchor } from "@/features/agent-workspace";
import type { PreviewSelectionRef } from "@/features/preview/store/preview-selection-slice";
import type { CogoPreviewAnchor } from "./types";

function clean(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

export function cogoJsonPathForAnchor(
  anchor: CogoPreviewAnchor,
): string | undefined {
  const block = clean(anchor.blockName ?? anchor.blockId);
  if (!block) return undefined;
  if (!anchor.propertyKey) return `/blocks/${escapePathSegment(block)}`;
  return `/blocks/${escapePathSegment(block)}/data/__aboxEnvelope/properties/${escapePathSegment(anchor.propertyKey)}`;
}

export function escapePathSegment(value: string): string {
  return value.replace(/~/g, "~0").replace(/\//g, "~1");
}

export function createPreviewAnchorFromSelection(input: {
  selection: PreviewSelectionRef;
  appId?: string;
  pageId?: string;
}): CogoPreviewAnchor {
  const anchor: CogoPreviewAnchor = {
    appId: input.appId,
    pageId: input.pageId,
    blockId: input.selection.blockId,
    blockName: input.selection.blockName,
    blockType: input.selection.blockType,
    propertyKey: input.selection.propertyKey,
    previewElementId: input.selection.selectedElementId,
    label: input.selection.blockName,
  };
  return {
    ...anchor,
    cogoJsonPath: cogoJsonPathForAnchor(anchor),
  };
}

export function createPreviewAnchorFromAgentWorkspaceAnchor(input: {
  anchor: AgentWorkspaceAnchor;
  appId?: string;
  propertyKey?: string;
}): CogoPreviewAnchor {
  const anchor: CogoPreviewAnchor = {
    appId: input.appId ?? input.anchor.refs.appId,
    pageId: input.anchor.refs.pageId,
    blockId: input.anchor.refs.blockId,
    blockName: input.anchor.refs.blockId,
    propertyKey: input.propertyKey ?? input.anchor.refs.propertyKey,
    previewElementId: input.anchor.refs.previewElementId,
    label: input.anchor.label,
  };
  return {
    ...anchor,
    cogoJsonPath: cogoJsonPathForAnchor(anchor),
  };
}
